import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
   faUserPlus,
   faUserXmark,
   faUsers,
} from '@fortawesome/free-solid-svg-icons'
import { useState, useContext, useEffect } from 'react'
import FriendCard from '../components/profile/FriendCard'
import FriendsContext from '../components/contexts/FriendsContext'
import GeneralContext from '../components/contexts/GeneralContext'

function Friends() {
   const [activeTab, setActiveTab] = useState('friends') // friends addFriends blockedUsers
   const [searchResults, setSearchResults] = useState([])
   const [userToSearch, setUserToSearch] = useState('')

   const { friendsData, setFriendsData } = useContext(FriendsContext)
   const {
      get_userInfo,
      get_current_blocked,
      get_current_friends,
      get_current_pending,
   } = useContext(GeneralContext)

   const performSearch = async () => {
      const userData = await get_userInfo(userToSearch)
      if (userData) {
         setSearchResults([userData])
      }
   }

   const handleInput = (e) => {
      setUserToSearch(e.currentTarget.value)
   }

   const refreshData = async () => {
      const friends = await get_current_friends()
      const pending = await get_current_pending()
      const blocked = await get_current_blocked()
      setFriendsData({
         ...friendsData,
         ['pending']: pending,
         ['current']: friends,
         ['blocked']: blocked,
      })
   }

   useEffect(refreshData, [])

   useEffect(() => {
      document.title = "Friends";
      document.documentElement.lang = "en";
  }, []);

   return (
      <div className="page_friends">
         <div className="Pane-Header">
            <h1> Friends </h1>
         </div>
         <div className="friends_bar">
            <div
               className="friends_bar_currentFriends iconsFriendsPagePositioning"
               onClick={() => {
                  get_current_friends()
                  setActiveTab('friends')
               }}
            >
               <FontAwesomeIcon
                  icon={faUsers}
                  className="icon_friends iconFriendsPage"
                  style={activeTab == 'friends' && { color: '#02c487' }}
               />
            </div>
            <div
               className="friends_bar_addFriends iconsFriendsPagePositioning"
               onClick={() => {
                  setActiveTab('addFriends')
               }}
            >
               <FontAwesomeIcon
                  icon={faUserPlus}
                  className="icon_add iconFriendsPage"
                  style={activeTab == 'addFriends' && { color: '#02c487' }}
               />
            </div>
            <div
               className="friends_bar_blockedFriends iconsFriendsPagePositioning"
               onClick={() => {
                  setActiveTab('blockedUsers')
               }}
            >
               <FontAwesomeIcon
                  icon={faUserXmark}
                  className="icon_block iconFriendsPage"
                  style={activeTab == 'blockedUsers' && { color: '#02c487' }}
               />
            </div>
         </div>
         <div className="friends_main">
            {(() => {
               if (activeTab == 'friends') {
                  //TODO: get friends
                  // console.log(friendsData)
                  return (
                     <ul className="friends_list">
                        {friendsData['current'].map((userInstance) => {
                           return (
                              <li className="friend_li">
                                 {(() => {
                                    if (
                                       sessionStorage.getItem('user') ==
                                       userInstance.fromUser.id
                                    ) {
                                       return (
                                          <FriendCard
                                             state={activeTab}
                                             username={
                                                userInstance.toUser.attributes
                                                   .username
                                             }
                                             name={
                                                userInstance.toUser.attributes
                                                   .name
                                             }
                                             description={
                                                userInstance.toUser.attributes
                                                   .description
                                             }
                                             image={
                                                userInstance.toUser.attributes
                                                   .profile_pic_src
                                             }
                                          />
                                       )
                                    } else {
                                       return (
                                          <FriendCard
                                             state={activeTab}
                                             username={
                                                userInstance.fromUser.attributes
                                                   .username
                                             }
                                             name={
                                                userInstance.fromUser.attributes
                                                   .name
                                             }
                                             description={
                                                userInstance.fromUser.attributes
                                                   .description
                                             }
                                             image={
                                                userInstance.fromUser.attributes
                                                   .profile_pic_src
                                             }
                                          />
                                       )
                                    }
                                 })()}
                              </li>
                           )
                        })}
                     </ul>
                  )
               } else if (activeTab == 'blockedUsers') {
                  //TODO: get blocked users
                  return (
                     <ul className="friends_list">
                        {friendsData['blocked'].map((userInstance) => {
                           return (
                              <li className="friend_li">
                                 <FriendCard
                                    state={activeTab}
                                    username={
                                       userInstance.toUser.attributes.username
                                    }
                                    name={userInstance.toUser.attributes.name}
                                    description={
                                       userInstance.toUser.attributes
                                          .description
                                    }
                                    image={
                                       userInstance.toUser.attributes
                                          .profile_pic_src
                                    }
                                    refreshData={refreshData}
                                 />
                              </li>
                           )
                        })}
                     </ul>
                  )
               } else if (activeTab == 'addFriends') {
                  //TODO: get blocked users
                  return (
                     <div>
                        <div className="friends_searchbar">
                           <input
                              className="friends_addFriends_search"
                              type="text"
                              placeholder="Type username here"
                              value={userToSearch}
                              onChange={handleInput}
                           />
                           <button className='friends_searchbar_button' onClick={performSearch}>Search</button>
                        </div>
                        <ul className="friends_list">
                           {searchResults.map((userInstance) => {
                              const userData = get_userInfo(userInstance)
                              console.log(userInstance)
                              return (
                                 <li className="friend_li">
                                    <FriendCard
                                       state={activeTab}
                                       username={
                                          userInstance.attributes.username
                                       }
                                       name={userInstance.attributes.name}
                                       description={
                                          userInstance.attributes.description
                                       }
                                       image={
                                          userInstance.attributes
                                             .profile_pic_src
                                       }
                                    />
                                 </li>
                              )
                           })}
                        </ul>
                     </div>
                  )
               }
            })()}
         </div>
      </div>
   )
}
export default Friends
